import { IGameState } from "State/Game/IGameState";
import { IAPStateHelper } from "State/Player/IAP/IAPStateHelper";
import { IPlayerState } from "State/Player/IPlayerState";
import { TimerType } from "System/Timer/TimerTypes";
import { getIAPRewards } from "Utility/Helpers/IAP/IAPRewards";
import { ProductId } from "Utility/Product";

export function resetPurchasedProducts(playerState: IPlayerState): IPlayerState {
    getIAPRewards().forEach(reward => {
        playerState = {
            ...playerState,
            productsPurchased: {
                ...playerState.productsPurchased,
                [reward.id]: 0,
            },
            purchases: 0,
            
        };
    });
    return playerState;
}

export function addToPurchaseHistory(
    playerState: IGameState,
    productId: ProductId,
    checkExistance = true
): IPlayerState {
    if (checkExistance && !getIAPRewards().some(reward => reward.id === productId)) {
        throw new Error('NO_OFFER_IN_THE_CODE');
    }
    const productData = getIAPRewards().find(product => product.id === productId);
    return IAPStateHelper.addPurchase(playerState, productData);
}

export function removeFromPurchaseHistory(
    playerState: IPlayerState,
    productId: ProductId,
    amount?: number
): IPlayerState {
    const haveAmount = playerState.productsPurchased[productId] || 0;
    if (haveAmount < 1) return playerState;
    const amountToRemove = amount === undefined ? haveAmount : Math.min(amount, haveAmount);
    return {
        ...playerState,
        purchases: playerState.purchases - amountToRemove,
        productsPurchased: {
            ...playerState.productsPurchased,
            [productId]: haveAmount - amountToRemove,
        },
    };
}

export function fillWith(str: string, symbol: string, desiredFinalStringLength: number, prefill = false): string {
    if (str.length >= desiredFinalStringLength) return str;
    const fillAmount = desiredFinalStringLength - str.length;
    if (prefill) str = symbol.repeat(fillAmount) + str;
    else str += symbol.repeat(fillAmount);
    return str;
}
